// extracted by mini-css-extract-plugin
export default {"badgeText":"LoginStatus_badgeText__M9V2Y"};